module.exports = __webpack_public_path__ + "static/file/2018_TodoMath_ActivityBook_Final.b7d492d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/2018_TodoMath_ActivityBook_Final.pdf
// module id = DVod
// module chunks = 18